//@flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import uniqueId from 'lodash/uniqueId';

import SmallLoadingWrapper from '../../../Loading/SmallLoadingWrapper';

import {
  patchOverviewEdits,
  updateOverviewEdits,
} from '../../../../redux/actions/overviewEditorActions';

import {
  closeOverviewModal,
  closeEditor,
} from '../../../../redux/actions/trekOverviewActions';

import InputWithWordCount from './InputWithWorldCount';
import { getToastMsg } from '../../../ErrorMessage';
import './highlights.css';

type Props = {
  trekId: string,
  closeEditor: () => void,
  highlights: Array<string>,
  renderedAsModal: boolean,
  closeOverviewModal: () => void,
};

type State = {
  loading: boolean,
};

class HighlightsEditor extends Component<Props, State> {
  state = { loading: false };

  render() {
    let { highlights } = this.props;
    const { renderedAsModal, closeOverviewModal } = this.props;

    const { loading } = this.state;

    highlights = this.whenHighlightsFieldEmpty(highlights);
    highlights = this.increaseHighlightsFieldToFive(highlights);

    return (
      <div id="highlight-editor">
        <div className="d-mobile">
          <div className="d-flex justify-content-between">
            {renderedAsModal && (
              <a onClick={closeOverviewModal}>
                <i className="icon icon-hg-chev-left" aria-hidden="true" />
              </a>
            )}
            <h2>HIGHLIGHTS</h2>
          </div>
        </div>
        <SmallLoadingWrapper showLoading={loading}>
          <div className="row">
            <div className="col-12 save-btn">
              <a onClick={this.handleSave}>
                <i className="icon icon-hg-save" aria-hidden="true" /> Save
              </a>
            </div>
            {highlights.map((highlight, index) => (
              <div className="col-12 form-group" key={uniqueId()}>
                <InputWithWordCount
                  value={highlight}
                  inputRef={el => (this[`highlight-${index}`] = el)}
                />
              </div>
            ))}
          </div>
        </SmallLoadingWrapper>
      </div>
    );
  }

  componentDidMount() {
    this.timeout = setTimeout(() => {
      window.addEventListener('click', this.handleOutsideClick);
    }, 10);
  }

  componentWillUnmount() {
    if (this.timeout) clearTimeout(this.timeout);
    window.removeEventListener('click', this.handleOutsideClick);
  }

  setLoadingState = status => this.setState(() => ({ loading: status }));

  whenHighlightsFieldEmpty = h => (!h || h.length === 0 ? (h = ['', '', '', '', '']) : h);

  handleSave = () => {
    const {
      patchOverviewEdits,
      updateOverviewEdits,
      closeOverviewModal,
      renderedAsModal,
      closeEditor,
      trekId,
    } = this.props;

    let { highlights } = this.props;

    highlights = this.whenHighlightsFieldEmpty(highlights);

    const newHighlights = highlights.reduce((acc, val, index) => {
      acc.push(this[`highlight-${index}`].props.value);
      return acc;
    }, []);

    this.setLoadingState(true);

    const patchObj = { highlights: newHighlights };
    patchOverviewEdits(trekId, patchObj)
      .then(() => {
        updateOverviewEdits(patchObj);
        if (renderedAsModal) {
          closeOverviewModal();
        } else {
          closeEditor();
        }
        getToastMsg({ status: 'success', type: 'changeTrekHighlights' });
        this.setLoadingState(false);
      })
      .catch(() => {
        getToastMsg({ status: 'error', type: 'changeTrekHighlights' });
        this.setLoadingState(false);
      });
  };

  handleOutsideClick = e => {
    const { loading } = this.state;
    if (!document.getElementById('highlight-editor').contains(e.target)) {
      if (!loading) {
        this.props.closeEditor();
      }
    }
  };

  increaseHighlightsFieldToFive(highlights) {
    if (highlights.length === 3) {
      highlights.push('');
      highlights.push('');
    }
    return highlights;
  }
}

const mapStateToProps = ({ selectedTrek, trekOverview }) => ({
  highlights: selectedTrek.trek.highlights,
  trekId: selectedTrek.trek.id,
  renderedAsModal: trekOverview.isModalOpen,
});

export default connect(
  mapStateToProps,
  {
    closeEditor,
    patchOverviewEdits,
    updateOverviewEdits,
    closeOverviewModal,
  }
)(HighlightsEditor);



// WEBPACK FOOTER //
// ./src/components/TrekDetail/Editors/Highlights/HighlightsEditor.jsx